import Cookies from 'js-cookie';
import { systemUserInfoApi } from '@service';

export default {
  namespace: 'userInfo',
  state: {
    user: {},
    code_list: [],
    menu_list: [],
    home_url: '',
  },
  reducers: {
    save(state, { payload }) {
      return payload;
    },
    updateUser(state, { payload }) {
      return { ...state, user: { ...state.user, ...payload } };
    },
  },
  effects: {
    *fetch(payload, { call, put }) {
      const { flag, data } = yield call(systemUserInfoApi);

      if (flag === 200) {
        yield put({ type: 'save', payload: data });
      }
    },
  },
  subscriptions: {
    setup({ dispatch, history }) {
      const query = new URLSearchParams(history.location.search);
      const ia_key = query.get('ia_key');

      if (ia_key) {
        // 获取顶级域名
        const domain = '.' + window.location.host.split('.').slice(-2).join('.');

        Cookies.set('ia_key', ia_key, { sameSite: 'none', secure: true, domain });
        // Cookies.set('force_logout', '1', { sameSite: 'none', secure: true, domain });
      }

      dispatch({ type: 'fetch' });
    },
  },
};
